import React, { useEffect } from 'react'
import './index.css'
import { useNavigate } from 'react-router-dom';

function WelcomeScreen() {

    const navigate = useNavigate()

 useEffect(() => {
  const timer = setTimeout(() => {
    navigate('/dashboard')
  }, 5000);

  return () => clearTimeout(timer);
}, []);

   


  return (
    <div>
     <div className="welcome-container">

<div className="confetti left">
  {Array.from({ length: 25 }).map((_, i) => (
    <span
      key={i}
      style={{
        '--x': `${Math.random() * 300 - 150}px`,
        '--r': `${Math.random() * 720}deg`,
        '--d': `${Math.random() * 0.5}s`
      }}
    ></span>
  ))}
</div>

<div className="confetti right">
  {Array.from({ length: 25 }).map((_, i) => (
    <span
      key={i}
      style={{
        '--x': `${Math.random() * 300 - 150}px`,
        '--r': `${Math.random() * 720}deg`,
        '--d': `${Math.random() * 0.5}s`
      }}
    ></span>
  ))}
</div>

  {/* 🎆 Left Fireworks */}
  <div className="fireworks left">
    <span></span>
    <span></span>
    <span></span>
  </div>

  {/* 🎆 Right Fireworks */}
  <div className="fireworks right">
    <span></span>
    <span></span>
    <span></span>
  </div>

  <div className="welcome-card">

    <h1 className="shop-name gold-text">
      SMR Gold Loan Finanace
    </h1>


    <p className="welcome-text">🎉 Welcome to Our Shop 🙏</p>

    <div className="address">
      <p>No. 17/21 Main Road, Zion Nagar, Vellalanvilai - 628219</p>
      <p>📞 +91 9790004209</p>
      <p>📧 maharajanramesh26@gmail.com</p>
    </div>

    {/* 🔥 Congrats Text */}
    <h2 className="congrats-text">✨ Congratulations! ✨</h2>

    {/* 🪙 Gold Coins Animation */}
    <div className="coins">
      <span>🪙</span>
      <span>🪙</span>
      <span>🪙</span>
    </div>

    {/* 🔗 Gold Chain Effect */}
    <div className="chain"></div>

    <div className="loader"></div>

  </div>
</div>
    </div>
  )
}

export default WelcomeScreen
